module.exports = __webpack_public_path__ + "img/dot.530de88e.svg";